// Generated from Figma Design Guidelines

export const ProductLineReferenceToImage = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M16.667 3.25049C19.2903 3.25049 21.417 5.37714 21.417 8.00049V12.0005C21.417 12.4147 21.0812 12.7505 20.667 12.7505C20.253 12.7502 19.917 12.4146 19.917 12.0005V8.00049C19.917 6.20556 18.4619 4.75049 16.667 4.75049H7.33398C5.53911 4.75055 4.08398 6.2056 4.08398 8.00049V11.1509C6.07002 10.9723 8.48263 11.2421 10.5225 12.3403C12.93 13.6367 14.7509 16.0557 14.751 20.0005C14.751 20.4146 14.415 20.7503 14.001 20.7505C13.9782 20.7505 13.9558 20.7486 13.9336 20.7466C13.9117 20.7485 13.8896 20.7505 13.8672 20.7505H7.33398C4.71069 20.7504 2.58398 18.6238 2.58398 16.0005V8.00049C2.58398 5.37717 4.71069 3.25055 7.33398 3.25049H16.667ZM9.81152 13.6606C8.04138 12.7077 5.86897 12.4741 4.08398 12.6577V16.0005C4.08398 17.7954 5.53911 19.2504 7.33398 19.2505H13.2236C13.0161 16.3253 11.5903 14.6185 9.81152 13.6606Z"
      fill="currentColor"
    />
    <circle cx="15.5996" cy="9.06641" r="1.75" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M16.8555 15.9468L19.3301 17.369L21.8048 15.9468"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M19.3301 20.2136V17.3691" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M17.0396 15.4024L18.8058 14.3827C19.1301 14.1954 19.5298 14.1954 19.8541 14.3827L21.6203 15.4024C21.9447 15.5897 22.1445 15.9358 22.1445 16.3104V18.3498C22.1445 18.7243 21.9447 19.0704 21.6203 19.2577L19.8541 20.2774C19.5298 20.4647 19.1301 20.4647 18.8058 20.2774L18.6263 20.1738L17.0396 19.2577C16.7152 19.0704 16.5154 18.7243 16.5154 18.3498V17.3301V16.3104C16.5154 15.9358 16.7152 15.5897 17.0396 15.4024Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
